import React, { useEffect } from "react";
// import debounce from "lodash.debounce";
import { BrowserRouter } from "react-router-dom";
import Header from "../Header";
import AppBody from "../Body";
import ErrorBoundary from "../ErrorBoundary";

/**
 * AppLayout component sets up the main layout of the application,
 * including handling viewport height updates and rendering 
 * the Header and AppBody components within a BrowserRouter and ErrorBoundary.
 *
 * @param {Object} props The props passed to the component.
 * @returns {ReactNode} The AppLayout component.
 */
const AppLayout = (props) => {
  // useEffect(() => {
  //   setVh();
  //   window.addEventListener("resize", debounce(setVh, 200), false);
  //   return () => window.removeEventListener("resize", setVh, false);
  // }, []);

  /**
   * Sets the viewport height (vh) CSS custom property based on the
   * current window inner height. This helps to handle viewport height 
   * issues on mobile browsers.
   */
  const setVh = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Header />
        <AppBody />
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default AppLayout;
